import { useState, useCallback } from 'react';

const getCsrfToken = () =>
  document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');

export const usePricingRates = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);

  const getPricingRates = useCallback(async ({ origin, destination }) => {
    setLoading(true);
    setError(null);

    try {
      const response = await fetch('/api/v5/pricing', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': getCsrfToken(),
        },
        body: JSON.stringify({
          pricing: {
            origin,
            destination,
            brand_id: window.gon?.current_brand || 'shipsticks',
            partner_id: window.gon?.partner_id || '',
          },
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const json = await response.json();
      setData(json);
      return { success: true, data: json };
    } catch (err) {
      setError(err.message);
      return { success: false, message: err.message };
    } finally {
      setLoading(false);
    }
  }, []);

  return { getPricingRates, loading, error, data };
};
